import { render, staticRenderFns } from "./AddGroupsToCompilation.vue?vue&type=template&id=fad39a26&scoped=true"
import script from "./AddGroupsToCompilation.vue?vue&type=script&lang=js"
export * from "./AddGroupsToCompilation.vue?vue&type=script&lang=js"
import style0 from "./AddGroupsToCompilation.vue?vue&type=style&index=0&id=fad39a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad39a26",
  null
  
)

export default component.exports